import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Footer from '../widgets/common/Footer'
import Header from '../widgets/common/Header'
import RBButton from '../controls/RBButton'
import { localize } from '../util/Localizer'
import Navigation from '../widgets/SubmitAClaim/Navigation'
import ProgressBar from '../widgets/SubmitAClaim/ProgressBar'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
// import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

// redux
import {
  updateUrl,
  setPercent,
  setNext,
  goNext,
  goBack,
  Cancel,
  submitAgain
} from '../redux/actions/submitNavigationActions'
import {
  submitClaim,
  updateClaim,
  clearClaim
} from '../redux/actions/submitAClaimActions'
import {
  changePage,
  setFilters,
  clearPeriodTotals
} from '../redux/actions/submitExpenseActions'
import {
  postClinic,
  clearSearch
} from '../redux/actions/submitPractitionerActions'

import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'

// pages
import Welcome from './SubmitAClaim/Welcome'
import Terms from './SubmitAClaim/Terms'
import ClaimConfirmation from './SubmitAClaim/ClaimConfirmation'
import MemberSelect from './SubmitAClaim/MemberSelect'
import HCSAExpenses from './SubmitAClaim/HCSAExpenses'
import ClaimType from './SubmitAClaim/ClaimTypeSelect'
import Practitioner from './SubmitAClaim/Practitioner/index'
import ClaimSubmissionOption from './SubmitAClaim/ClaimSubmissionOption'
import ClaimTypeBenefit from './SubmitAClaim/ClaimTypeBenefitSelect'
import ClaimExpenses from './SubmitAClaim/ClaimExpenses'
import CertifcationAndAuthorization from './SubmitAClaim/CertifcationAndAuthorization'
import NgrxUtils from '../util/NgrxUtils'
import HcsaFilter from '../widgets/SubmitAClaim/hcsaFilter'

class SubmitAClaim extends Component {
  constructor () {
    super()
    this.submitClaimSection = undefined
    this.submitClaimSectionAssign = node => {
      this.submitClaimSection = node
    }
    this.renderProgress = this.renderProgress.bind(this)
    this.adjustScrollBar = this.adjustScrollBar.bind(this)
    this.submitClaim = this.submitClaim.bind(this)
    this.showConfirmation = this.showConfirmation.bind(this)
    this.ShowErrorDialog = this.ShowErrorDialog.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
    this.state = {
      open: false
    }
  }

  componentWillUnmount () {
    this.clearFilters()
  }

  renderProgress () {
    if (this.props.currentPage === null || this.props.pageStack === []) {
      return null
    } else {
      return (
        <div>
          <ProgressBar progress={this.props.percent} />
          <br />
        </div>
      )
    }
  }

  adjustScrollBar () {
    const node = this.submitClaimSection
    if (node && node.scrollTop > 75) {
      node.scrollTop = 0
    }
  }

  submitClaim () {
    let submitClaimObject = {}
    const { claimObj } = this.props
    // default mva to false when not selected
    const { MVARelated: MvaRelated, type, ...otherClaimProperties } = claimObj
    const nextMva = MvaRelated === 'true' ? 'true' : 'false'
    const EhcClaim = type !== 'Drug' && type !== 'Dental'
    if (claimObj && claimObj.claimSubmitType === 'photoUpload') {
      submitClaimObject = { ...otherClaimProperties, type: type, MvaRelated: EhcClaim ? nextMva : 'false' }
    } else {
      const removeKeys = ['policyNumber', 'member', 'cob', 'patient', 'claimType', 'type', 'categoryCode', 'claimSubmitType']
      const _claimObject = NgrxUtils.removeKeys(removeKeys, claimObj)

      submitClaimObject = {
        HCSAParameters: _claimObject.HCSAExpenseLines ? _claimObject.HCSAExpenseLines : null,
        DentalParameters: (_claimObject.DentalClaimLines && _claimObject.DentalClaimLines.length > 0) ? _claimObject : null,
        DrugParameters: (_claimObject.DrugClaimLines && _claimObject.DrugClaimLines.length > 0) ? _claimObject : null,
        EHCParameters: (_claimObject.ExtendedHealthCareLines && _claimObject.ExtendedHealthCareLines.length > 0) ? _claimObject : null,
        MvaRelated: EhcClaim ? nextMva : 'false'
      }
    }

    // Check if claim has sumbitter successfully or if an error has occured
    this.props.submitClaim(submitClaimObject, () => this.showConfirmation(), () => this.ShowErrorDialog())
  }

  handleOpen () {
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
    this.props.submitAgain()
    this.props.clearClaim()
    this.props.clearSearch()
  }

  showConfirmation () {
    this.props.clearSearch()
    this.props.setNext('submit')
    this.props.goNext()
  }
  // if an error is returned during claim submission we display dialog
  ShowErrorDialog () {
    if (this.props.submitClaimError) {
      this.handleOpen()
    }
  }

  clearFilters () {
    let obj = {
      name: 'All',
      type: 'All',
      startDate: null,
      endDate: null
    }
    this.props.setFilters(obj)
    this.props.changePage(1)
  }

  render () {
    const actions = [
      <RBButton
        key='clickToProceed'
        variant='outlined'
        label={localize('common.clickToProceed')}
        primary={false}
        onClick={this.handleClose}
      />
    ]
    const appContent = this.props.appContent.content
    const hcsa = this.props.currentPage === 'expense' ? 'hcsaFilterMargin' : null
    return (
      <div className={`pageContent  ${hcsa}`}>
        <Header />
        {this.props.currentPage === 'expense' ? <HcsaFilter ref={(comp) => { this.filterBar = comp }} /> : null}
        <section id='submitAClaim' ref={this.submitClaimSectionAssign} className={'mainContent'}>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
          >
            <DialogTitle>{localize('pages.SubmitAClaim.ErrorModal')}</DialogTitle>
            <DialogActions>{actions}</DialogActions>
          </Dialog>
          <Grid fluid style={{ paddingRight: '1rem', paddingLeft: '1rem' }}>
            <Row center='xs' className='submitContent'>
              <Col xs={12} sm={10}>
                <br />
                <Row end='xs' middle='xs'>
                  <Col xs={1}>
                    {/* Video Icon will not be needed for production Launch, will be added at a later date */}
                    {/* {this.props.helpUrl ? <HelpVideo url={this.props.helpUrl} /> : null} */}
                  </Col>
                </Row>
                {this.renderProgress()}
                {this.props.currentPage === null || this.props.pageStack === []
                  ? <Welcome appContent={appContent.submitClaimGetStarted} updateUrl={this.props.updateUrl} goNext={this.props.goNext} setNext={this.props.setNext} setPercent={this.props.setPercent}/> : null}
                {this.props.currentPage === 'terms'
                  ? <Terms appContent={appContent.submitClaimTerms} updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} adjustScrollBar={this.adjustScrollBar} updateClaim={this.props.updateClaim} /> : null}
                {this.props.currentPage === 'member'
                  ? <MemberSelect updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar} /> : null}
                {this.props.currentPage === 'claimType'
                  ? <ClaimType updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar} isHCSAAvailable={this.props.isHCSAAvailable} /> : null}
                {this.props.currentPage === 'claimTypeBenefit'
                  ? <ClaimTypeBenefit updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} /> : null}
                {this.props.currentPage === 'submitOption'
                  ? <ClaimSubmissionOption updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar} /> : null}
                {this.props.currentPage === 'expense' // hcsa expenses
                  ? <HCSAExpenses updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar}/> : null}
                {this.props.currentPage === 'claimExpense'
                  ? <ClaimExpenses appContent={appContent.submitClaimExpensesVerification} updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar} /> : null}
                {this.props.currentPage === 'practitioner'
                  ? <Practitioner updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar} claimObj={this.props.claimObj} /> : null}
                {this.props.currentPage === 'certifcationAndAuthorization'
                  ? <CertifcationAndAuthorization appContent={appContent.submitClaimAuthorization} updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} updateClaim={this.props.updateClaim} adjustScrollBar={this.adjustScrollBar} /> : null}
                {this.props.currentPage === 'submit'
                  ? <ClaimConfirmation updateUrl={this.props.updateUrl} setNext={this.props.setNext} setPercent={this.props.setPercent} Cancel={this.props.Cancel} adjustScrollBar={this.adjustScrollBar} clear={this.props.clearClaim} /> : null}
                <br />
                {this.props.currentPage === null || this.props.currentPage === 'submit' ? null
                  : <Navigation
                    pageNext={this.props.pageNext}
                    goNext={this.props.goNext}
                    goBack={this.props.goBack}
                    submitClaim={this.submitClaim}
                    currentPage={this.props.currentPage}
                    pageStack={this.props.pageStack}
                    showLoading={this.props.isLoading}
                    Cancel={this.props.Cancel}
                    clear={this.props.clearClaim}
                    clearTotals={this.props.clearPeriodTotals} />}
                <br />
              </Col>
            </Row>
          </Grid>
          <Footer />
        </section>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    isLoading: state.SubmitAClaimReducer.isLoading || state.SubmitAClaimReducer.isSubmitAClaimLoading || false,
    error: state.SubmitAClaimReducer.error || null,
    helpUrl: state.SubmitNavigationReducer.helpUrl || null,
    percent: state.SubmitNavigationReducer.percent || 0,
    pageNext: state.SubmitNavigationReducer.pageNext || null,
    currentPage: state.SubmitNavigationReducer.currentPage || null,
    pageStack: state.SubmitNavigationReducer.pageStack || [],
    memberSummary: state.memberSummaryReducer.memberSummary,
    submitClaimError: state.SubmitAClaimReducer.submitClaimError || {},
    claimObj: state.SubmitAClaimReducer.claimObj || {},
    appContent: state.AppContentReducer.appContent
  }
}
const ConnectedSubmitAClaim = connect(mapStateToProps, {
  updateUrl,
  setPercent,
  setNext,
  goNext,
  goBack,
  push,
  Cancel,
  submitClaim,
  updateClaim,
  clearClaim,
  submitAgain,
  changePage,
  setFilters,
  postClinic,
  clearSearch,
  clearPeriodTotals
})(injectIntl(SubmitAClaim))

export default ConnectedSubmitAClaim



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim.js